'use client';

import Script from 'next/script';

const GA4_IDS = {
  local: 'G-NJK21B3F97',
  staging: 'G-XXXXXXXXXX',
  production: 'G-NJK21B3F97',
};

export function GoogleAnalytics() {
  const environment = process.env.NEXT_PUBLIC_ENV || 'local';
  const ga4Id = GA4_IDS[environment as keyof typeof GA4_IDS];

  if (!ga4Id) return null;

  return (
    <>
      {/* Google Analytics Base Script */}
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${ga4Id}`}
        strategy="afterInteractive"
      />
      
      {/* Google Analytics Configuration */}
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${ga4Id}');
        `}
      </Script>
    </>
  );
}
